import type { UseFormReturn } from 'react-hook-form'
import type {
  GenerateRiskOutResult,
  RiskOutGenerationMode,
} from '@/shared/hooks/api/machineryDirectiveCompliance'
import type { CreateHazardRiskReductionStepFormValues } from './CreateHazardRiskReductionStepForm.schema'

export function applyRiskOutGenerationResult(
  form: UseFormReturn<CreateHazardRiskReductionStepFormValues>,
  mode: RiskOutGenerationMode,
  result: GenerateRiskOutResult
) {
  if (mode === 'dimensions' || mode === 'both') {
    if ('riskOutInjury' in result) {
      form.setValue('riskOutInjury', result.riskOutInjury)
      form.setValue('riskOutFrequency', result.riskOutFrequency)
      form.setValue('riskOutAvoidance', result.riskOutAvoidance)
      form.setValue('riskOutLikelihood', result.riskOutLikelihood)
    }
  }

  if (mode === 'justifications' || mode === 'both') {
    if ('riskOutInjuryJustification' in result) {
      form.setValue(
        'riskOutInjuryJustification',
        result.riskOutInjuryJustification
      )
      form.setValue(
        'riskOutFrequencyJustification',
        result.riskOutFrequencyJustification
      )
      form.setValue(
        'riskOutAvoidanceJustification',
        result.riskOutAvoidanceJustification
      )
      form.setValue(
        'riskOutLikelihoodJustification',
        result.riskOutLikelihoodJustification
      )
    }
  }

  form.clearErrors()
}
